import AjaxLogin from './ajaxLogin';
import '../_plugins/form-validator.min';
import Global from './global';

const $ = jQuery.noConflict();

'use strict';
const Register = {
	/** @description Initialize */

	init: function() {
		this.bindEvents();
		this.onlyNums();
		// Add validator

		this.formValidation();

		const entries = performance.getEntriesByType('navigation');
		const entryType = entries.map(nav => nav.type);
		if (entryType.indexOf('back_forward') >= 0) {
			if ($('#autocomplete').length > 0) {
				$('#autocomplete').val('');
				$('.js-register__country-dropdown').val('').trigger('change');
				$('#postal_code').val('');
				$('#locality').val('');
				$('.js-register__state-dropdown').val('').trigger('change');
			}
		}

		this.passwordFieldEvents();

		setTimeout(() => {
			$('.register input').attr('autocomplete', 'negative');
		}, 1000);

		const notAvailableCombinations = [
			'123456789',
			'987654321',
			'000000000',
			'111111111',
			'222222222',
			'333333333',
			'444444444',
			'555555555',
			'666666666',
			'777777777',
			'888888888',
			'999999999'
		]

		$('.js-only-num-tax-id').on('input', function() {
			if($(this).val().length !== 9 || notAvailableCombinations.includes($(this).val())) {
				$('.js-only-num-tax-id-error').show();
				$(this).addClass('tax-error');
			} else {
				$('.js-only-num-tax-id-error').hide();
				$(this).removeClass('tax-error');
			}
		});
	},

	passwordFieldEvents() {
		const passwordIcon = $('.js-register__form-row--password .eye-icon');

		passwordIcon.on('click', function() {
			$(this).toggleClass('change-icon');

			if($(this).hasClass('change-icon')) {
				$(this).prev().attr('type', 'text');
			} else {
				$(this).prev().attr('type', 'password');
			}
		})
	},

	onlyNums() {
		const numberFields  = document.querySelectorAll('.js-only-num');
		if (!numberFields.length) {
			return;
		}
		numberFields.forEach(function(input) {
			input.addEventListener('input', function() {
				// Remove any non-digit character
				this.value = this.value.replace(/[^\d]/g, '');
			});
		});

	},

	bindEvents: () => {
		$('.js-register__form-dropdown').on('change', function(e) {
			$('.js-register__form .other-type-wrap').toggleClass('hidden', $(e.target).val().trim() !== 'Other');
			setTimeout(() => {
				$(this).parent().parent().removeClass('has-error');
				$(this).parent().parent().find('.form-error').hide();
			}, 100);
		});

		$('.js-register__country-dropdown').on('change', function(e) {
			setTimeout(() => {
				$(this).parent().parent().removeClass('has-error');
				$(this).parent().parent().find('.form-error').hide();
			}, 100);
		});

		$('.js-register__state-dropdown').on('change', function(e) {
			setTimeout(() => {
				$(this).parent().parent().removeClass('has-error');
				$(this).parent().parent().find('.form-error').hide();
			}, 100);
		});

		$('.js-register__form .other-type').on('blur', function(e) {
			$('.js-register__form .other-type-form-error').toggleClass('hidden', $(e.target).val() !== '');
			$('.js-register__form .other-type-wrap').toggleClass('has-error', $(e.target).val() === '');
		});

		$('.js-register__form-btn').on('click', function(e) {
			Register.onSubmit(e);
		});

		$('.js-register__form .sameAddress').on('change', function() {
			const shippingSameAddress = $('.js-register__form .sameAddress:checked').val() !== 'on';
			$('.js-register__form .shipping-details-wrapp').toggleClass('hidden', shippingSameAddress);
		});

		$('.js-register__form #regesc_html_email').on('mouseout', function(e) {
			Register.onEmailBlur(e);
		});
		$('.js-register__unapproved-popup button').on('click', function() {
			$.fancybox.close();
		});

		if ($('.woocommerce-form-login').length) {
			$('.woocommerce-form-login input[name=username]').on('blur', function(e) {
				Register.onUsernameBlur(e);
			});
		}

		$('.js-login__unapproved-popup button').on('click', function() {
			$.fancybox.close();
		});
	},

	scrollToTop: () => {
		$([document.documentElement, document.body]).animate({
			scrollTop: $('body').offset().top
		}, 800);
	},

	registerPopup: (trigger, popup, customClass = '') => {
		$(trigger).fancybox({
			src: popup,
			type: 'inline',
			smallBtn: true,
			baseClass: customClass
		});
	},

	formValidation: () => {
		$.validate();
	},

	onSubmit: (e) => {
		e.preventDefault();

		// Prevent submission if Tax ID has error
		if ($('.js-only-num-tax-id').hasClass('tax-error')) {
			Register.mainErrorMessage('Please provide a valid 9-digit Tax ID.');
			return;
		}

		$('.js-register__form [data-validation]').trigger('blur');

		const regBtn = $('.js-register__form-btn');
		const loader = $(regBtn).find('.loader');
		regBtn.addClass('register__form-btn--hidden');
		loader.removeClass('hidden');
		Register.mainErrorMessage('');

		const regFormValues = {
			action: 'register-customer',
			firstName: $('.js-register__form input[name="first-name"]').val(),
			lastName: $('.js-register__form input[name="last-name"]').val(),
			company: $('.js-register__form input[name="company"]').val(),
			email: $('.js-register__form input[name="email"]').val(),
			password: $('.js-register__form input[name="password"]').val(),
			repeatPassword: $('.js-register__form input[name="repeatPassword"]').val(),
			phone: $('.js-register__form input[name="phone"]').val(),
			businessType: $('.js-register__form .business-type').val().trim(),
			otherBusinessType: $('.js-register__form .other-type').val(),
			taxID: $('.js-register__form input[name="tax-id"]').val(),
			address: $('.js-register__form input[name="address"]').val(),
			zipCode: $('.js-register__form input[name="zipCode"]').val(),
			city: $('.js-register__form input[name="city"]').val(),
			state: $('.js-register__form select[name="state"]').val(),
			country: $('.js-register__form select[name="country"]').val(),
			shippingFirstName: $('.js-register__form input[name="shipping-first-name"]').val(),
			shippingLastName: $('.js-register__form input[name="shipping-last-name"]').val(),
			shippingCompany: $('.js-register__form input[name="shipping-company"]').val(),
			shippingAddress: $('.js-register__form input[name="shipping-address"]').val(),
			shippingZipCode: $('.js-register__form input[name="shipping-zipCode"]').val(),
			shippingCity: $('.js-register__form input[name="shipping-city"]').val(),
			shippingState: $('.js-register__form select[name="shipping-state"]').val(),
			shippingCountry: $('.js-register__form select[name="shipping-country"]').val(),
		};

		regFormValues['shipping'] = $('.js-register__form input[name="sameAddress"]:checked').val() === 'on';

		$('.js-register__form .select2-selection--single').css('borderColor', '');
		$('.js-register__form .register__form-row .has-error').removeClass('has-error');
		$('.js-register__form .form-error').remove();

		$.ajax({
			url: kadraGlobal.ajax,
			type: 'POST',
			dataType: 'JSON',
			data: regFormValues,
			success: function(response) {
				if (response.success === true && response.data.customerID > 0) {
                    window.location.href = response.data.redirect;
					// $.fancybox.open({
					// 	src: '.js-register__popup',
					// 	type: 'inline',
					// 	smallBtn: true,
					// 	baseClass: 'aaa'
					// });
					loader.addClass('hidden');
					regBtn.removeClass('register__form-btn--hidden');
					$('.js-register__form input').val('');
					$('.js-register__form .has-error').removeClass('has-error');
				} else if (response.success === false) {
					loader.addClass('hidden');
					regBtn.removeClass('register__form-btn--hidden');
					Register.scrollToTop();
					Register.mainErrorMessage(response.data);
				}
				Register.applyValidationErrors(response.data.errors);
			},
		});
	},

	mainErrorMessage: (msg) => {
		$('.js-register__form .error-wrap')
			.html(msg)
			.toggleClass('error-wrap--padding', msg !== '');
	},

	applyValidationErrors: (errors) => {

		if (!errors || errors.length === 0) {
			return;
		}

		$.each(errors, function(key, value) {
			let Ctrl = $('.js-register__form [name="' + key + '"]');
			let Parent = Ctrl.closest('.register__form-row--half').length
				? Ctrl.closest('.register__form-row--half')
				: Ctrl.closest('.register__form-row');
			Parent.addClass('has-error');
			Parent.find('span.form-error').remove();
			Parent.append('<span class="help-block form-error">' + value + '</span>');
		});

		$('.js-register__form .loader').addClass('hidden');
		$('.js-register__form-btn').removeClass('register__form-btn--hidden');
		Register.scrollToTop();
		Register.mainErrorMessage('Please fill out all required fields.');
	},

	onEmailBlur: (e) => {
		if ($('.js-register__form [name="email"]').val().length < 3) {
			return;
		}
		$.ajax({
			url: kadraGlobal.ajax,
			type: 'POST',
			dataType: 'JSON',
			data: {
				action: 'customer-check-status',
				email: $('.js-register__form [name="email"]').val(),
			},
			success: function(response) {
				if (response.success === true && response.data.status === '0') {
					$.fancybox.open({
						src: '.js-register__unapproved-popup',
						type: 'inline',
						smallBtn: true,
						baseClass: 'aaa'
					});
				}
			},
		});
	},

	onUsernameBlur: (e) => {
		if ($('.js-register__form').length) {
			if ($('.js-register__form [name="username"]').val().length < 3) {
				return;
			}
		}

		$.ajax({
			url: kadraGlobal.ajax,
			type: 'POST',
			dataType: 'JSON',
			data: {
				action: 'customer-check-status',
				username: $('.js-register__form [name="username"]').val(),
			},
			success: function(response) {
				if (response.success === true && response.data.status === '0') {
					$.fancybox.close();
					AjaxLogin.closeForm(); // close all possible opened dialogs
					$.fancybox.open({
						src: '.js-login__unapproved-popup',
						type: 'inline',
						smallBtn: true,
						baseClass: 'aaa'
					});
				}
			},
		});
	},

};

export default Register;
